import { AxiosResponse } from "axios";
import { httpClient } from "./API";

export type UrlTrackingAccessRecordResponse = Record<string, never>;

export const recordUrlTrackingAccessAPI = async (
  trToken: string
): Promise<AxiosResponse<UrlTrackingAccessRecordResponse>> => {
  return httpClient.post(
    "core/internal/calgary/urlTrackingAccesses",
    null,
    { params: { tr_token: trToken } }
  );
};
